/* eslint-disable eqeqeq */
import { handleTabToNext } from '../../formKit';
import { ACCESSORY_FORM_CONFIGS } from '../accessoryFormConfigs';
import { useAccessoryForm } from '../useAccessoryForm';
import { AccessoryHeading, AccSubtab, APSelect } from '../accessoryFieldKit';
import MountingSection from '../MountingSection';
import AccessoryMountingPopup, {
  CasingMountSpecialParameters,
} from '../AccessoryMountingPopup';
import { CasingMountRow } from './LouverForm';
import type { AccessoryFormProps } from '../AccessoryFormHost';

/**
 * Phase 6e2b-1 — ADP GAGE form (accessories/adp_gage/{form.js 83,
 * form.tmpl 280}, read in full). Smallest clone: master_adp_gage_id ←
 * adp_gage_params (mfg + model only) + mounting.
 * loadPositionWhenAlreadySelected (boot rule #329).
 * Tmpl quirk: the first subtab's data-subtab is "gage" (NOT 'properties' —
 * the config key is dead); replicated.
 * (Row label renders "APD Gage" — tab.accessories owns that rename.)
 */
const config = ACCESSORY_FORM_CONFIGS.adp_gage;

const AdpGageForm = ({ row, section, tunnel, expanded }: AccessoryFormProps) => {
  const api = useAccessoryForm({
    config,
    row,
    section,
    tunnel,
    expanded,
    labeledSubtabs: ['mounting'],
  });
  const { model } = api;
  if (api.loading || !model) {
    return <div className="preloader dotted-preloader active" />;
  }
  const cid = row.id;

  return (
    <>
      <AccessoryHeading api={api} target="master_adp_gage_id" visClass="vis-adp_gage" />
      <form ref={(el) => { api.formRef.current = el; }} onKeyDown={handleTabToNext}>
        <ul className="inputs-group sublist">
          <AccSubtab api={api} type="adp_gage" cid={cid} name="gage" sublistClass="max-height-auto">
            <APSelect api={api} target="master_adp_gage_id" name="mfg_id" label="Manufacturer" required cmsPath="manufacturer" />
            <APSelect api={api} target="master_adp_gage_id" name="model" label="Model" required cmsPath="model" labelKey="model" valueKey="model" />
          </AccSubtab>

          <MountingSection
            api={api}
            type="adp_gage"
            cid={cid}
            variant="clone"
            sublistDisabled={model.get('master_adp_gage_id') === null}
          >
            {/* inline casing_mount radio row (adp_gage tmpl — 6e2b verifier). */}
            <CasingMountRow api={api} />
          </MountingSection>
        </ul>
      </form>
      <div id={`popup_accessory_mounting_${row.id}`} className="popup-wrapper location-popup">
        <div className="popup-content popup-content-animation" />
      </div>
      <AccessoryMountingPopup
        api={api}
        typeName="adp gage"
        typeValue="adp_gage"
        SpecialParameters={CasingMountSpecialParameters}
      />
    </>
  );
};

export default AdpGageForm;
